import { apiClient } from './client';
import { anonymousTestHandler } from '../anonymousTestHandler';

export interface Question {
  _id: string;
  Question: string;  // Capitalized to match backend
  Type: number;      // Capitalized to match backend
  Category: string;  // Capitalized to match backend
}

export interface TestSession {
  test_id: string;
  temp_user_id: string | null;
  questions: Question[];
}

export interface SaveAnswerRequest {
  question_id: string;
  value: number;
  temp_user_id: string | null;
}

export interface TestResults {
  primaryType: number;
  wing?: number | null;
  scores: {
    [key: string]: number
  };
  resultsToken?: string;
}

export const questionsApi = {
  getTestQuestions: async (): Promise<TestSession> => {
    const response = await apiClient.get('/questions/test');
    return response.data;
  },

  saveAnswer: async (testId: string, data: SaveAnswerRequest): Promise<void> => {
    await apiClient.post(`/questions/test/${testId}/answer`, data);
  },

  submitTest: async (testId: string, data: {
    temp_user_id: string | null;
    answers?: { [key: string]: number }
  }): Promise<TestResults> => {
    const response = await apiClient.post(`/questions/test/${testId}/results`, data);
    const results = response.data;

    if (!results || typeof results.primaryType !== 'number' || !results.scores) {
      throw new Error('Invalid results format from server');
    }

    if (results.resultsToken) {
      anonymousTestHandler.storeTestResults(results.resultsToken, results.primaryType);
    }

    return results;
  },
};
